export const handleSubmitForm = async (values, onSubmitIncentive) => {
  try {
    const uploadData = {
      slipImage: values.slipImage ? values.slipImage[0] : null,
      employeeId: values.employeeId,
      branchId: values.branchId,
      branchName: values.branchName,
      barcodeValue: values.barcodeValue,
      scanTimestamp: values.scanTimestamp,
      priceBill: values.priceBill,
    };

    onSubmitIncentive(uploadData);
  } catch (error) {
    const uploadData = {
      slipImage: values.slipImage ? values.slipImage[0] : null,
      employeeId: values.employeeId,
      branchId: values.branchId,
      branchName: values.branchName,
      barcodeValue: values.barcodeValue,
      scanTimestamp: values.scanTimestamp,
      priceBill: values.priceBill,
    };

    onSubmitIncentive(uploadData);
  }
};
